import { render, staticRenderFns } from "./classShow.vue?vue&type=template&id=0082b18a&scoped=true"
import script from "./classShow.vue?vue&type=script&lang=js"
export * from "./classShow.vue?vue&type=script&lang=js"
import style0 from "./classShow.vue?vue&type=style&index=0&id=0082b18a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0082b18a",
  null
  
)

export default component.exports